exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tinymce-containerty[data-v-06cffe43] {\n  position: relative;\n  line-height: normal;\n}\n.tinymce-containerty[data-v-06cffe43] .mce-fullscreen {\n  z-index: 10000;\n}\n.tinymce-textarea[data-v-06cffe43] {\n  visibility: hidden;\n  z-index: -1;\n}\n.editor-custom-btn-container[data-v-06cffe43] {\n  position: absolute;\n  right: 4px;\n  top: 4px;\n  /*z-index: 2005;*/\n}\n.fullscreen .editor-custom-btn-container[data-v-06cffe43] {\n  z-index: 10000;\n  position: fixed;\n}\n.editor-upload-btn[data-v-06cffe43] {\n  display: inline-block;\n}\n", ""]);

// exports
